import { render, staticRenderFns } from "./RedirectModal.vue?vue&type=template&id=cd2726a8&"
import script from "./RedirectModal.controller.js?vue&type=script&lang=js&"
export * from "./RedirectModal.controller.js?vue&type=script&lang=js&"
import style0 from "./RedirectModal.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports